module.exports = __webpack_public_path__ + "static/media/cargamasiva.2bb2ac40.svg";